import React from 'react'
import { styled } from 'linaria/react'
import { BaseCarousel } from './BaseCarousel'
import Link from '../Link'
import Image from '@jetshop/ui/Image/Image'
import { getStringByPropertyName } from '../Util/Helpers'
import { theme } from '../../Theme'
import { useResponsiveBreakpoint } from '../../../hooks/useResponsiveBreakpoint'

const CarouselWrapper = styled.div`
  background-color: #ffffff;

  .keen-slider-wrapper {
    background-color: #ffffff !important;
  }
`

const CategoryLink = styled(Link)`
    text-align: center;
`

const CategorySlide = styled.div`
  min-width: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  
  .category-image-container {
    width: 100px;
    overflow: hidden;
    transition: scale 0.2s ease-in-out;
    
    &:hover {
      scale: 1.05;
    }
  }
  
  .category-title {
    font-family: var(--font-industry);
    font-weight: 700;
    font-size: 0.9rem;
    color: var(--color-black);
    text-decoration: none;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.3;
    
    &:hover {
      opacity: 0.8;
      text-decoration: none;
    }
    
    ${theme.below.md} {
      font-size: 0.9rem;
    }
    
    ${theme.below.sm} {
      max-width: 110px;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
      -webkit-line-clamp: unset;
      -webkit-box-orient: unset;
    }
  }
`

const Title = styled.h5`
  margin-bottom: 0.5rem;
  font-family: var(--font-industry);
  font-weight: 700;
  color: var(--color-black);
`

export const FeatureCategoriesCarousel = ({ 
  categories = [], 
  title = "Populära kategorier",
  hideTitle = false,
  customSettings = {}
}) => {
  const { currentBreakpoint } = useResponsiveBreakpoint()
  
  // Responsive perView settings based on breakpoints
  const getResponsivePerView = () => {
    switch (currentBreakpoint) {
      case 'xs':
        return 3
      case 'sm':
        return 4
      case 'md':
        return 5
      case 'lg':
        return 5
      case 'xl':
        return 6
      case 'xxl':
        return 7
      case 'xxxl':
        return 8
      case 'xxxxl':
        return 10
      default:
        return 4
    }
  }

  const settings = {
    perView: getResponsivePerView(),
    spacing: 0,
    showArrows: true,
    ...customSettings
  }

  if (categories.length === 0) return null
  
  return (
    <CarouselWrapper className="px-128 py-32">
      {(title && !hideTitle) && <Title>{title}</Title>}
      <BaseCarousel settings={settings}>
        {categories.map((category, index) => {
          const categoryTitle = getStringByPropertyName(category?.properties, 'text') || category?.name
          const categoryLink = getStringByPropertyName(category?.properties, 'link') || category?.url
          const categoryImage = getStringByPropertyName(category?.properties, 'image') || category?.image
          //const altText = getStringByPropertyName(category?.properties, 'altText') || categoryTitle

          return (
            <CategorySlide key={index} className="keen-slider__slide">
              <CategoryLink to={categoryLink} title={categoryTitle}>
                <div className="category-image-container">
                  <Image
                    src={categoryImage}
                    aspect="1:1"
                    // The slide container is a fixed 100px wide.
                    sizes="100px"
                  />
                </div>
                <div className="category-title">
                  {categoryTitle}
                </div>
              </CategoryLink>
            </CategorySlide>
          )
        })}
      </BaseCarousel>
    </CarouselWrapper>
  )
}